import TourLoja from "../components/TourLoja";
import Lookbook from "../components/Lookbook";
import InstagramStrip from "../components/InstagramStrip";

export default function LojaPage() {
  return (
    <div data-testid="page-loja" className="pt-24 sm:pt-32">
      <TourLoja />
      <Lookbook />
      <InstagramStrip />
    </div>
  );
}
